{
  "dss": {
    "button": {
      "back": "Vissza",
      "cancel": "Mégsem",
      "close": "Bezárás",
      "confirmDelete": "Igen, törlés",
      "continue": "Folytatás",
      "logout": "Kijelentkezés",
      "passwordReset": "Jelszó visszaállítása",
      "save": "Mentés",
      "verify": "Ellenőrzés"
    },
    "error": {
      "403": "Nincs hozzáférése ehhez az oldalhoz.",
      "404": "Ez az oldal nem létezik.",
      "generic": "Hiba történt. Kérjük, próbálja meg később.",
      "invalidConfirmationLink": "A megerősítő link lejárt vagy más módon érvénytelen.",
      "throttling": "Túl sok kísérlet. Ez a művelet egy ideig blokkolva van.",
      "title": "Hiba",
      "title403": "Hozzáférés megtagadva",
      "title404": "Nem található"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Privacy Policy",
      "terms": "Terms & Conditions"
    },
    "label": {
      "CRMAccountNumber": "CRM-fiók száma",
      "contact": "Contact",
      "email": "E-mail",
      "faq": "FAQ",
      "female": "Ms.",
      "firstname": "Vezetéknév",
      "help": "Help",
      "language": "Nyelv",
      "lastname": "Vezetéknév",
      "male": "Mr.",
      "needHelp": "kell segítség?",
      "newPassword": "Új jelszó",
      "newPassword2": "Új jelszó megerősítése",
      "oldPassword": "Jelenlegi jelszó",
      "organization": "Szervezet",
      "password": "Jelszó",
      "required": "required",
      "salutation": "Szalutáció",
      "select": "Please select"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Confirm Registration",
        "wait": "Please wait to complete account confirmation."
      },
      "otp": {
        "btnResend": "Ellenőrző kód újraküldése e-mailben",
        "msg": {
          "invalidOTP": "A megadott egyszeri jelszó érvénytelen.",
          "resendFail": "Nem sikerült újra elküldeni a kódot. Kérjük, próbálja meg később újra."
        },
        "spamDetail": "Ellenőrizze a postaládáját és a spam mappát a STIHL Support (noreply{'@'}stihl-sso.com)  e-mailjeiért.",
        "spamTitle": "Nem kapott e-mailt?",
        "subtitle": "A folytatáshoz igazolnia kell e-mail címét.",
        "title": "Ellenőrizze felhasználói fiókját",
        "txtVerifyMail": "Kérjük, írja be a ***** e-mail {email} címre küldött ellenőrző kódot."
      },
      "personal": {
        "msg": {
          "noChange": "There is nothing to update.",
          "updateError": "Failed to update personal data.",
          "updated": "Personal data was updated.",
          "userLoadErr": "Error loading user data. Please try again later."
        },
        "secOrganization": "Organization",
        "secPersonal": "Személyes",
        "secSettings": "Preferált beállítások",
        "title": "Személyes információ"
      },
      "postPwSet": {
        "info": "Mostantól használhatja az új jelszavát.",
        "link_name": "Continue to Self-Service",
        "link_url": "/user/ui/",
        "title": "A jelszava megváltozott"
      },
      "resetPW": {
        "title": "Jelszó visszaállítása"
      },
      "security": {
        "2fa": {
          "availableMethods": "Elérhető 2FA módszerek:",
          "info": "A kétfaktoros hitelesítés (2FA) egy biztonsági funkció, amely extra védelmi réteget ad fiókjához. Két bejelentkezési módszert igényel, nem csak felhasználónevet és jelszót.",
          "method": {
            "email": "E-mail",
            "emailDesc": "Egyszer használatos kódokat kaphat e-mailben a hitelesítési kérelmek teljesítéséhez.",
            "oath": {
              "add": {
                "button": "Hitelesítő alkalmazás regisztrálása"
              }
            }
          }
        },
        "authenticator": "Hitelesítő alkalmazás",
        "infoFederatedAccount": "Ezt a fiókot a szervezete identitásszolgáltatója kezeli, ezért a jelszót itt nem lehet megváltoztatni. A jelszó megváltoztatásához jelentkezzen be szervezete bejelentkezési oldalán, vagy forduljon informatikai rendszergazdájához.",
        "lastUse": "Utolsó használat: {0}.",
        "msg": {
          "invalidPassword": "Érvénytelen jelenlegi jelszó megadva.",
          "passwordAlreadyUsed": "Az utolsó 5 jelszó nem használható fel újra.",
          "pwUpdateError": "Hiba történt a jelszó módosítása során.",
          "pwUpdated": "A jelszó megváltozott."
        },
        "noDevice": "Nincs konfigurálva",
        "oathAdd": {
          "appInfo": "A STIHL bejelentkezési folyamatának megkönnyítése érdekében használhat hitelesítő alkalmazásokat, mint például a {0}, {1}, {2} stb., egyszer használatos jelszó generálására, amelyet második tényezőként használ a bejelentkezési folyamat során.<br/>Ha elvesztette vagy elfelejtette mobileszközét, akkor is bármikor használhatja az e-mailben küldött 2FA kódot.<br/><br/>Kérjük, kövesse az alábbi utasításokat a hitelesítő eszköz beállításához.",
          "badCode": "Érvénytelen kód, kérjük, próbálja újra.",
          "error": "Hiba történt a hitelesítő eszköz regisztrálása során.",
          "headScan": "1. Olvassa be a QR-kódot a hitelesítő alkalmazással",
          "headVerify": "2. Ellenőrizze a kódot",
          "infoKey": "beállítási kulcs",
          "infoKeyTitle": "A kétfaktoros titka",
          "infoScanBottom": "Nem sikerült beolvasni? A {0} segítségével manuálisan konfigurálhatja a hitelesítő alkalmazást.",
          "infoVerify": "Írd be a hitelesítő alkalmazásod által generált kódot.",
          "success": "A hitelesítő eszközöd regisztrálva lett. Most már használhatod a bejelentkezéshez.",
          "title": "Regisztráld a kétfaktoros hitelesítési eszközödet"
        },
        "oathDelete": {
          "error": "Hiba történt a hitelesítő eszköz törlésekor.",
          "success": "A hitelesítő eszköz törölve lett."
        },
        "passkeys": {
          "about": {
            "info1": "A jelszavak kriptográfiai kulcspárok (egy nyilvános kulcs és egy privát kulcs), amelyeket egy Ön által vezérelt hitelesítő tárol. A hitelesítő bizonyítani tudja, hogy a felhasználó jelen van, és jogosult a jelszó használatára. A hitelesítők PIN-kóddal, jelszóval, biometrikus kóddal vagy eszközjelszóval igazolják az engedélyezést, a hitelesítő képességeitől és konfigurációjától függően. A hitelesítők sokféle formában léteznek, például iPhone vagy Android eszközön, Windows Hello-n, FIDO2 hardveres biztonsági kulcson vagy jelszókezelőn.",
            "info2": "Amikor jelszóval jelentkezik be a STIHL-be, a hitelesítő nyilvános kulcsú titkosítást használ a személyazonossága STIHL-nek történő igazolására anélkül, hogy valaha is elküldené a jelszót. A jelszavak egy webhely domainjéhez vannak kötve, például a stihl-sso.com-hoz, és biztonságos kapcsolatot igényelnek, ami azt jelenti, hogy a webböngésző megtagadja a hitelesítést egy hasonló adathalász webhelyen. Ezek a tulajdonságok a jelszavakat rendkívül adathalászat-biztossá teszik, és sokkal nehezebben támadhatók, mint az SMS vagy a TOTP 2FA, amelyek adathalász célpontok lehetnek.",
            "info3": "A felhőalapú jelszószolgáltatások lehetővé teszik a jelszók szinkronizálását eszközök (például Apple-eszközök, Android-eszközök vagy jelszókezelők) között, így több helyről is használhatók, és kevésbé könnyen elvesznek. Miután beállított egy szinkronizált jelszót egy eszközön, az a jelszó több eszközön is használható ugyanazon szolgáltatás használatával. Például, ha regisztrál egy jelszót az iCloud-fiókjában a MacBook Touch ID-jával, akkor ezt a jelszót felcserélhetően használhatja arcfelismeréssel, ujjlenyomattal, PIN-kóddal vagy eszközjelszóval több, ugyanahhoz az iCloud-fiókhoz kapcsolódó eszközön.",
            "title": "A jelszókról"
          },
          "add": {
            "button": "Új jelszó hozzáadása",
            "error": "Hiba történt az új jelszó hozzáadásakor.",
            "success": "Új jelszó hozzáadva."
          },
          "delete": {
            "button": "Jelszó törlése",
            "error": "Hiba történt a jelszó törlésekor.",
            "success": "A jelszó törölve lett."
          },
          "edit": {
            "error": "Hiba történt a jelszó nevének mentése közben.",
            "name": "Jelszó neve",
            "success": "A jelszó neve frissült.",
            "title": "Adjon nevet a jelszavának, hogy megkülönböztesse azt a többi jelszavatól"
          },
          "info": "A jelszó egy egyszerű és biztonságos alternatíva a jelszavakhoz, amelyek érintéssel, arcfelismeréssel, eszközjelszóval vagy PIN-kóddal igazolják személyazonosságát.",
          "none": "Nincs konfigurált jelszó.",
          "reallyDelete": "Biztosan törölni szeretné a jelszót?",
          "registeredPasskeys": "Az Ön regisztrált jelszavai:",
          "title": "Jelszavak"
        },
        "reallyDeleteDevice": "Biztosan törölni szeretné a hitelesítő eszközt?",
        "secMFA": "Kéttényezős hitelesítés",
        "secPwdChange": "Jelszó módosítása",
        "title": "Biztonság"
      },
      "setPW": {
        "acceptTC": "Please confirm our {terms} and read our {privacy}.",
        "killSSO": "Az összes aktív munkamenet érvénytelenítése",
        "msg": {
          "tokenExpired": "The password link or code expired. Please follow the link to reset your password: {link}."
        },
        "privacy": "Data Privacy Policy",
        "terms": "Terms and Conditions",
        "title": "Új jelszó megadása"
      }
    },
    "validations": {
      "hasDigit": "Számjegyet kell tartalmaznia",
      "hasLowercase": "Kisbetűs karaktert kell tartalmaznia",
      "hasSpecial": "Speciális karaktert kell tartalmaznia: {chars}",
      "hasUppercase": "Nagybetűs karaktert kell tartalmaznia",
      "invalidCharacters": "Érvénytelen karaktereket tartalmaz",
      "maxLength": "Maximális {max} szükséges karakterek",
      "minLength": "Minimum {min} szükséges karakterek",
      "notSameAsEmail": "Túl hasonló az e-mail címhez",
      "onlyValidCharactersAllowed": "Csak betűk, számok és szóközök engedélyezettek.",
      "required": "Kötelező érték",
      "sameAsPassword": "A jelszavak nem egyeznek",
      "tcAccepted": "Kérjük, erősítse meg feltételeinket.",
      "validEmail": "Érvénytelen e-mail cím.",
      "validOTP": "Kérjük, adja meg az ellenőrző kódot."
    }
  }
}
